import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { loginState } from './loginState';

import { PreferredLanguage } from 'app/types/language';
import { AlertNotification } from 'app/types/notifications';

export const loginSlice = createSlice({
  name: 'login',
  initialState: loginState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setIsAuthUser: (state, action: PayloadAction<boolean>) => {
      state.isAuthUser = action.payload;
    },
    setRequestPendingTo: (state, action: PayloadAction<boolean>) => {
      state.isRequestPending = action.payload;
    },
    setPreferredLanguage: (state, action: PayloadAction<PreferredLanguage>) => {
      state.preferredLanguage = action.payload;
    },
    setNotificationMessage: (
      state,
      action: PayloadAction<AlertNotification>,
    ) => {
      state.notification.type = action.payload.type;
      state.notification.message = action.payload.message;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: loginActions } = loginSlice;

/* ------- STATE SELECTORS ------- */
export const selectLogin = (state: RootState) => state.login || loginState;

export const makeSelectAuthUser = () =>
  createSelector(selectLogin, login => login.isAuthUser);

export const makeSelectNotification = () =>
  createSelector(selectLogin, login => login.notification);

export const makeSelectRequestStatus = () =>
  createSelector(selectLogin, login => login.isRequestPending);

export const makeSelectPreferredLanguage = () =>
  createSelector(selectLogin, login => login.preferredLanguage);

export default loginSlice.reducer;
